export default __webpack_public_path__ + "static/backplate-efb191ce36755cf06215cd8f93654520.png";